import Vue from "vue";
import Vuex from "vuex";
import Api from "@/services/api";
import { getAuthorizationToken } from "@/services/utils";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    apiErrors: {},
    currentUser: null,
    adminCurrentView: null,
    groups: [],
    surveys: [],
    survey_groups_details: [],
    plans_by_name: [],
    plans: [],
    braintree_token: "",
    surveyDetails: null,
    questionDetails: null,
    presentations: [],
    responses_by_scores: {},
    presentations_metrics: [],
    presentationDetails: null,
    responses: [],
    defaultQuestions: [],
    users: [],
    selectedUserPresentationdetails: {},
    presentationQuestions: {},
    showResetMessage: false,
    group_manager: null,
    managers: [],
    group: null,
    surveys_questions: null,
    survey_groups: [],
    actionSteps: {
      "Content: Audience-Oriented": {
        "Messages": {
          "The Presentation Road Map": "https://torchmetrics.s3.amazonaws.com/uploads/action_steps/Content_Messages-Step-1-Create-your-road-map.pdf",
          "Identify key messages": "https://torchmetrics.s3.amazonaws.com/uploads/action_steps/Content_Messages-Step-2-Idenfity-key-messages.pdf",
          "Ask colleagues for feedback": "https://torchmetrics.s3.amazonaws.com/uploads/action_steps/Content_Messages-Step-3-Ask-colleague-for-feedback.pdf"
        },
        "Call to Action": {
          "Analyze three of your action steps": "https://torchmetrics.s3.amazonaws.com/uploads/action_steps/Content_Call-to-Action-Step-1-Action-step-criteria.pdf",
          "Conclude your presentation with a call to action": "https://torchmetrics.s3.amazonaws.com/uploads/action_steps/Content_Call-to-Action-Step-2-Conclude-with-call-to-action.pdf",
          "Begin with a strong action verb": "https://torchmetrics.s3.amazonaws.com/uploads/action_steps/Content_Call-to-Action-Step-3-Use-action-verb.pdf",
        },
        "Executive Summary": {
          "Write concise and organized executive summary": "https://torchmetrics.s3.amazonaws.com/uploads/action_steps/Content_Executive-Summary-Step-1-Write-executive-summary.pdf",
          "List key categories": "https://torchmetrics.s3.amazonaws.com/uploads/action_steps/Content_Executive-Summary-Step-2-Use-key-categories.pdf",
          "Practice!": "https://torchmetrics.s3.amazonaws.com/uploads/action_steps/Content_Executive-Summary-Step-3-Compose-email.pdf",
        },
        "Focused Content": {
          "Focuses on interests of the listeners": "https://torchmetrics.s3.amazonaws.com/uploads/action_steps/Content_Focused-Content-Step-1-Highlight-listerner_s-interests.pdf",
          "Cut less helpful details": "https://torchmetrics.s3.amazonaws.com/uploads/action_steps/Content_Focused-Content-Step-2-Cut-details.pdf",
          "Ask colleagues for feedback": "https://torchmetrics.s3.amazonaws.com/uploads/action_steps/Content_Focused-Content-Step-3-Ask-colleague-for-feedback.pdf",
        },
        "Details": {
          "Include only the essential information": "https://torchmetrics.s3.amazonaws.com/uploads/action_steps/Content_Details-Step-1-Include-essential-information.pdf",
          "Reduce word count by 25%": "https://torchmetrics.s3.amazonaws.com/uploads/action_steps/Content_Details-Step-2-Reduce-word-count.pdf",
          "Ask colleagues for feedback": "https://torchmetrics.s3.amazonaws.com/uploads/action_steps/Content_Details-Step-3-Ask-colleague-for-feedback.pdf",
        },
        "Content Organization": {
          "Organize your thoughts": "https://torchmetrics.s3.amazonaws.com/uploads/action_steps/Content_Content-Organization-Step-1-Use-business-formats.pdf",
          "Include three transition/linking phrases": "https://torchmetrics.s3.amazonaws.com/uploads/action_steps/Content_Content-Organization-Step-2-Include-transition-phrases.pdf",
          "Write informative titles for each slide": "https://torchmetrics.s3.amazonaws.com/uploads/action_steps/Content_Content-Organization-Step-3-Write-informative-titles.pdf",
        },
        "Length": {
          "Time yourself from start to finish": "https://torchmetrics.s3.amazonaws.com/uploads/action_steps/Content_Length-Step-1-Time-your-rehearsal.pdf",
          "Allot time for questions and answers": "https://torchmetrics.s3.amazonaws.com/uploads/action_steps/Content_Length-Step-2-Allott-time-for-questions.pdf",
          "Prepare a shorter version of your presentation": "https://torchmetrics.s3.amazonaws.com/uploads/action_steps/Content_Length-Step-3-Prepare-shorter-version.pdf",
        },
        "Stories/Examples": {
          "Write an example/story using this Story Structure": "https://torchmetrics.s3.amazonaws.com/uploads/action_steps/Content_Stories-Examples-Step-1-Use-story-structure.pdf",
          "Use phrases to bring your ideas to life": "https://torchmetrics.s3.amazonaws.com/uploads/action_steps/Content_Stories-Examples-Step-2-Use-introductory-phrases.pdf",
          "Rehearse your example/story": "https://torchmetrics.s3.amazonaws.com/uploads/action_steps/Content_Stories-Examples-Step-3-Rehearse-story-with-colleague.pdf",
        },
      },
      "Visuals: Message-Focused": {
        "Number of Slides": {
          "Use Presentation Road Map": "https://torchmetrics.s3.amazonaws.com/uploads/action_steps/Visuals_Number-of-Slides-Step-1-Use-presentation-road-map.pdf",
          "Consolidate Slides": "https://torchmetrics.s3.amazonaws.com/uploads/action_steps/Visuals_Number-of-Slides-Step-2-Consolidate-slides.pdf",
          "Decide time spent on each slide": "https://torchmetrics.s3.amazonaws.com/uploads/action_steps/Visuals_Number-of-Slides-Step-3-Plan-time-for-each-slide.pdf",
        },
        "Amount of Text": {
          "Reduce sentences to short phrases": "https://torchmetrics.s3.amazonaws.com/uploads/action_steps/Visuals_Amount-of-Text-Step-1-Reduce-sentences-to-phrases.pdf",
          "Using interesting graphic": "https://torchmetrics.s3.amazonaws.com/uploads/action_steps/Visuals_Amount-of-Text-Step-2-Use-interesting-graphic.pdf",
          "Convert wordy slides into tables": "https://torchmetrics.s3.amazonaws.com/uploads/action_steps/Visuals_Amount-of-Text-Step-3-Convert-wordy-slides-to-tables.pdf",
        },
        "Clarity of Visuals": {
          "Analyze your visuals": "https://torchmetrics.s3.amazonaws.com/uploads/action_steps/Visuals_Clarity-of-Visuals-Step-1-Analyze-your-visuals.pdf",
          "Look at inspiring visuals": "https://torchmetrics.s3.amazonaws.com/uploads/action_steps/Visuals_Clarity-of-Visuals-Step-2-Look-at-inspiring-visuals.pdf",
          "Learn how to display numbers": "https://torchmetrics.s3.amazonaws.com/uploads/action_steps/Visuals_Clarity-of-Visuals-Step-3-Learn-how-to-display-numbers.pdf",
        },
        "Number of Visuals/Charts": {
          "Delete three visuals": "https://torchmetrics.s3.amazonaws.com/uploads/action_steps/Visuals_Number-of-Visuals.Charts-Step-1-Delete-three-visuals.pdf",
          "Look at compelling visuals": "https://torchmetrics.s3.amazonaws.com/uploads/action_steps/Visuals_Number-of-Visuals.Charts-Step-2-Look-at-compelling-visuals.pdf",
          "Ask colleagues for feedback": "https://torchmetrics.s3.amazonaws.com/uploads/action_steps/Visuals_Number-of-Visuals.Charts-Step-3-Ask-colleagues-for-feedback.pdf",
        },
      },
      "Delivery: Persuasive and Confident": {
        "Voice Volume": {
          "Record yourself": "https://torchmetrics.s3.amazonaws.com/uploads/action_steps/Delivery_Voice-Volume-Step-1-Record-yourself.pdf",
          "Ask colleagues for feedback": "https://torchmetrics.s3.amazonaws.com/uploads/action_steps/Delivery_Voice-Volume-Step-2-Ask-colleague-for-feedback.pdf",
          "Review a resource to improve": "https://torchmetrics.s3.amazonaws.com/uploads/action_steps/Delivery_Voice-Volume-Step-3-Review-a-resource-to-improve.pdf"
        },
        "Voice Clarity": {
          "Identify the help you need": "https://torchmetrics.s3.amazonaws.com/uploads/action_steps/Delivery_Voice-Clarity-Step-1-Identify-help-you-need.pdf",
          "Improve pronunciation": "https://torchmetrics.s3.amazonaws.com/uploads/action_steps/Delivery_Voice-Clarity-Step-2-Improve-pronounciation.pdf",
          "Ask colleagues for feedback": "https://torchmetrics.s3.amazonaws.com/uploads/action_steps/Delivery_Voice-Clarity-Step-3-Ask-colleague-for-feedback.pdf",
        },
        "Voice Energy": {
          "Rehearse out loud": "https://torchmetrics.s3.amazonaws.com/uploads/action_steps/Delivery_Voice-Energy-Step-1-Emphasize-as-rehearse-out-loud.pdf",
          "Ask colleagues for feedback": "https://torchmetrics.s3.amazonaws.com/uploads/action_steps/Delivery_Voice-Energy-Step-2-Ask-colleague-for-feedback.pdf",
          "Listen to TED talks": "https://torchmetrics.s3.amazonaws.com/uploads/action_steps/Delivery_Voice-Energy-Step-3-Listen-to-TED-Talks.pdf",
        },
        "Pauses": {
          "Practice pausing for three": "https://torchmetrics.s3.amazonaws.com/uploads/action_steps/Delivery_Pauses-Step-1-Practice-pausing-for-three.pdf",
          "Pause before key messages": "https://torchmetrics.s3.amazonaws.com/uploads/action_steps/Delivery_Pauses-Step-2-Pause-before-key-message__1_.pdf",
          "Highlight where slow down": "https://torchmetrics.s3.amazonaws.com/uploads/action_steps/Delivery_Pauses-Step-3-Highlight-where-slow-down.pdf"
        },
        "Filler Words": {
          "Tape yourself": "https://torchmetrics.s3.amazonaws.com/uploads/action_steps/Delivery_Filler-Words-Step-1-Tape-yourself.pdf",
          "Start sentence without filler words": "https://torchmetrics.s3.amazonaws.com/uploads/action_steps/Delivery_Filler-Words-Step-2-Start-sentence-with-no-filler-word.pdf",
          "Ask colleagues for feedback": "https://torchmetrics.s3.amazonaws.com/uploads/action_steps/Delivery_Filler-Words-Step-3-Ask-colleague-for-feedback.pdf",
        },
        "Hand Gestures": {
          "Practice three key tips": "https://torchmetrics.s3.amazonaws.com/uploads/action_steps/Delivery_Hand-Gestures-Step-1-Practice-three-key-tips.pdf",
          "Watch these three videos": "https://torchmetrics.s3.amazonaws.com/uploads/action_steps/Delivery_Hand-Gestures-Step-2-Watch-three-videos.pdf",
          "Ask colleagues for feedback": "https://torchmetrics.s3.amazonaws.com/uploads/action_steps/Delivery_Hand-Gestures-Step-3-Ask_colleague-for-feedback.pdf",
        },
        "Body Movements": {
          "Record yourself": "https://torchmetrics.s3.amazonaws.com/uploads/action_steps/Delivery_Body-Movements-Step-1-Record-yourself.pdf",
          "Identify habits to change": "https://torchmetrics.s3.amazonaws.com/uploads/action_steps/Delivery_Body-Movements-Step-2-Identify-habits-to-change.pdf",
          "Ask colleagues for feedback": "https://torchmetrics.s3.amazonaws.com/uploads/action_steps/Delivery_Body-Movements-Step-3-Ask-colleague-for-feedback.pdf",
        },
        "Posture": {
          "Ask colleagues for feedback": "https://torchmetrics.s3.amazonaws.com/uploads/action_steps/Delivery_Posture-Step-1-Ask-colleague-for-feedback.pdf",
          "Learn from Esther Gokhale": "https://torchmetrics.s3.amazonaws.com/uploads/action_steps/Delivery_Posture-Step-2-Learn-from-Esther-Gokhale.pdf",
          "Apply tips": "https://torchmetrics.s3.amazonaws.com/uploads/action_steps/Delivery_Posture-Step-3-Apply-tips-to-improve-posture.pdf",
        },
      },
      "Connection: Engaged and Authentic": {
        "Relevance": {
          "Two ways information relevant": "https://torchmetrics.s3.amazonaws.com/uploads/action_steps/Connection_Relevance-Step-1-Two-ways-information-relevant.pdf",
          "Three ways audience impacted": "https://torchmetrics.s3.amazonaws.com/uploads/action_steps/Connection_Relevance-Step-2-Three-ways-audience-impacted.pdf",
          "Ask audience impact question": "https://torchmetrics.s3.amazonaws.com/uploads/action_steps/Connection_Relevance-Step-3-Ask-audience-impact-question.pdf",
        },
        "Eye Contact": {
          "Ask colleagues for feedback": "https://torchmetrics.s3.amazonaws.com/uploads/action_steps/Connection_Eye-Contact-Step-1-Ask-colleague-for-feedback.pdf",
          "Rehearse with eye contact": "https://torchmetrics.s3.amazonaws.com/uploads/action_steps/Connection_Eye-Contact-Step-2-Rehearse-with-eye-contact.pdf",
          "Tell audience where to look": "https://torchmetrics.s3.amazonaws.com/uploads/action_steps/Connection_Eye-Contact-Step-3-Tell-audience-where-to-look.pdf"
        },
        "Add Value": {
          "Add story example": "https://torchmetrics.s3.amazonaws.com/uploads/action_steps/Connection_Add-Value-Step-1-Add-story-example.pdf",
          "Identify where interpret numbers": "https://torchmetrics.s3.amazonaws.com/uploads/action_steps/Connection_Add-Value-Step-2-Identiy-where-interpret-numbers.pdf",
          "Watch TED Talks ": "https://torchmetrics.s3.amazonaws.com/uploads/action_steps/Connection_Add-Value-Step-3-Watch-Ted-Talks.pdf",
        },
        "Connect": {
          "Write opening and closing statements": "https://torchmetrics.s3.amazonaws.com/uploads/action_steps/Connection_Connect-Step-1-Write-opening-closing-statements.pdf",
          "Choose three online engaging ideas": "https://torchmetrics.s3.amazonaws.com/uploads/action_steps/Connection_Connect-Step-2-Choose-three-online-engaging-ideas.pdf",
          "Explore sharing opinions, facts, and feelings": "https://torchmetrics.s3.amazonaws.com/uploads/action_steps/Connection_Connect-Step-3-Explore-sharing-opinions-facts-feelings.pdf.pdf",
        },
        "Questions + Answers": {
          "Plan when to let listeners talk": "https://torchmetrics.s3.amazonaws.com/uploads/action_steps/Connection_Questions-Answers-Step-1-Plan-when-let-listeners-talk.pdf",
          "Ask colleagues for feedback": "https://torchmetrics.s3.amazonaws.com/uploads/action_steps/Connection_Questions-Answers-Step-2-Ask_colleague-for-feedback.pdf",
          "Prepare a second conclusion": "https://torchmetrics.s3.amazonaws.com/uploads/action_steps/Connection_Questions-Answers-Step-3-Prepare-second-conclusion.pdf",
        },
        "Background": {
          "Take screenshot of background ": "https://torchmetrics.s3.amazonaws.com/uploads/action_steps/Online_Background-Step-1-Take-screen-shot-of-background.pdf",
          "Identify design ideas for your space": "https://torchmetrics.s3.amazonaws.com/uploads/action_steps/Online_Background-Step-2-Identify-design-ideas-for-your-space.pdf",
          "Use tasteful virtual background": "https://torchmetrics.s3.amazonaws.com/uploads/action_steps/Online_Background-Step-3-Use-tasteful-virtual-background.pdf",
        },
        "Lighting": {
          "Record test meeting": "https://torchmetrics.s3.amazonaws.com/uploads/action_steps/Online_Lighting-Step-1-Record-test-meeting.pdf",
          "Learn about three-point lighting": "https://torchmetrics.s3.amazonaws.com/uploads/action_steps/Online_Lighting-Step-2-Learn-about-three-point-lighting.pdf",
          "Identify additional lighting needs": "https://torchmetrics.s3.amazonaws.com/uploads/action_steps/Online_Lighting-Step-3-Identify-additional-lighting-needs.pdf",
        },
        "Camera Position": {
          "Position camera at eye level": "https://torchmetrics.s3.amazonaws.com/uploads/action_steps/Online_Camera-Position-Step-1-Postition-camera-eye-level.pdf",
          "Center the body in frame": "https://torchmetrics.s3.amazonaws.com/uploads/action_steps/Online_Camera-Position-Step-2-Center-body-in-frame.pdf",
          "Watch the pros": "https://torchmetrics.s3.amazonaws.com/uploads/action_steps/Online_Camera-Position-Step-3-Watch-the-pros.pdf",
        },
        "Voice Quality": {
          "Record yourself": "https://torchmetrics.s3.amazonaws.com/uploads/action_steps/Online_Voice-Quality-Step-1-Record-yourself.pdf",
          "Purchase microphone": "https://torchmetrics.s3.amazonaws.com/uploads/action_steps/Online_Voice-Quality-Step-2-Purchase-microphone.pdf",
          "Minimiz background noise": "https://torchmetrics.s3.amazonaws.com/uploads/action_steps/Online_Voice-Quality-Step-3-Minimize-background-noise.pdf",
        },
      }
    },
  },
  getters: {
    isSuperAdmin(state) {
      var superAdmins = [
        "claudyne@wilderpresentations.com",
        "email4@example.com",
      ];
      return (
        state.currentUser != null &&
        superAdmins.includes(state.currentUser.email)
      );
    },
    isGroupManager(state) {
      return state.currentUser && (state.currentUser.admin || state.currentUser.kind === 'group_manager');
    },
    groupById: (state) => (id) => {
      return state.groups.find((group) => group.id == id);
    },
  },
  mutations: {
    CLEAR_CURRENT_USER(state) {
      state.currentUser = null
      state.adminCurrentView = null
      window.localStorage.removeItem("authToken")
      window.localStorage.removeItem("currentUser")
    },
    CLEAR_GROUP_MANAGER(state) {
      state.group_manager = null;
    },
    CLEAR_SURVEY_DETAILS: (state) => (state.surveyDetails = null),
    CLEAR_API_ERRORS: (state) => (state.apiErrors = {}),
    CLEAR_API_LOGIN_ERRORS: (state) => (state.apiErrors.LOG_IN = null),
    CLEAR_RESET_MESSAGE_FLAG: (state) => (state.showResetMessage = false),
    SET_API_ERROR: (state, error) => (state.apiErrors = { ...state.apiErrors, ...error }),
    SET_CURRENT_USER(state, user) {
      window.localStorage.setItem("currentUser", JSON.stringify(user.data));
      state.currentUser = user.data
      if (user.headers['authorization']) {
        let formatedToken = user.headers['authorization'].split(' ')
        window.localStorage.setItem("authToken", formatedToken[1])
      }
    },
    SET_ADMIN_CURRENT_VIEW: (state, view) => (state.adminCurrentView = view),
    SET_GROUPS: (state, groups) => (state.groups = groups),
    SET_GROUP_DETAILS: (state, group) => (state.group = group),
    SET_PRESENTATION_DETAILS: (state, details) =>
      (state.presentationDetails = details),
    SET_PRESENTATIONS_METRICS(state, presentations_metrics) {
      state.presentations_metrics = presentations_metrics;
    },
    SET_RESPONSES_BY_SCORES(state, response) {
      let { data } = response;
      const keys = [0, 20, 40, 60, 80, 100];
      
      keys.forEach(key => {
        if(!(key in data)) data[key] = 0;
      });
      
      state.responses_by_scores = {
        ...state.responses_by_scores,
        [response.category]: data
      };
    },
    SET_QUESTION_DETAILS: (state, details) => {
      details.action_steps = details.action_steps.filter(action_step => action_step.action_step_id)
      details.action_steps.forEach(action_step => {
        action_step.additional_content =
          action_step.additional_content.filter(content => content.additional_contents_id)
      })
      if (details.answers) {
        details.answers = details.answers.sort(function (a, b) { return a.answer_id - b.answer_id })
      }
      state.questionDetails = details;
    },
    SET_RESET_MESSAGE_FLAG: (state, flag) => {
      state.showResetMessage = flag;
    },
    SET_RESPONSES: (state, responses) =>
    (state.responses = responses.filter(
      (r) => r.user_id == state.currentUser.id
    )),
    SET_SURVEY_DETAILS: (state, details) => {
      details.questions.forEach((question) => {
        if (question.answers) {
          question.answers = question.answers.sort(function (a, b) {
            return a.answer_id - b.answer_id;
          });
        }
      });
      state.surveyDetails = details;
    },
    SET_SURVEY_GROUPS_DETAILS(state, data) {
      state.survey_groups_details = data
    },
    // TODO: Design a better handling for partial modifications over the
    // state.currentUser. All modifications made to state.currentUser should
    // generate an update of the item stored in the local storage (currentUser)
    // So, it is better to have a unique function in charge of modifying any
    // attribute(s) in the state.currentUser and updating the local storage.
    // This function does that only for the 'onboarding' attribute.
    SET_CURRENT_USER_ONBOARDING: (state, value) => {
      state.currentUser.onboarding = value
      window.localStorage.setItem("currentUser", JSON.stringify(state.currentUser))
    },
    SET_SURVEYS: (state, surveys) => (state.surveys = surveys),
    SET_PLANS: (state, plans) => (state.plans = plans),
    SET_SURVEY_QUESTIONS: (state, data) => {
      const getUniqueQuestions = function(data) {
        let questions = [];
        data.forEach(question => {
          if (!questions.find(q => q.id === question.id)) questions.push(question);
        });
        return questions;
      };
      const survey_questions = data.reduce((acc, survey_group) => {
        return [
          ...acc,
          {
            id: survey_group.id,
            name: survey_group.name,
            online: getUniqueQuestions(survey_group.surveys.reduce((acc, survey) => {
              if (survey.format === 'online' && (survey.title === 'Get deep feedback' || survey.title === 'Overall Presentation Skills')) return [...acc, ...survey.questions];
              return [...acc];
            }, [])),
            in_person: getUniqueQuestions(survey_group.surveys.reduce((acc, survey) => {
              if (survey.format === 'in_person' && (survey.title === 'Get deep feedback' || survey.title === 'Overall Presentation Skills')) return [...acc, ...survey.questions];
              return [...acc];
            }, [])),
          }
        ];
      }, []);
      state.surveys_questions = survey_questions;
    },
    SET_SURVEY_GROUPS: (state, data) => {
      const survey_groups = data.reduce((acc, survey_group) => {
        return [
          ...acc,
          { 
            id: survey_group.id, 
            name: survey_group.name,
            description: survey_group.description,
            num_online: survey_group.surveys.filter(survey => survey.format === 'online').length || 0,
            num_in_person: survey_group.surveys.filter(survey => survey.format === 'in_person').length || 0,
          }
        ];
      }, []);
      state.survey_groups = survey_groups;
    },
    SET_PLANS_BY_NAME: (state, plan) => {
      Vue.set(state.plans_by_name, plan.name, plan)
    },
    SET_BRAINTREE_TOKEN: (state, token) => (state.braintree_token = token),
    SET_USERS: (state, users) => (state.users = users),
    SET_GROUP_MANAGER: (state, group_manager) => (state.group_manager = group_manager),
    SET_GROUP_MANAGERS: (state, group_managers) => (state.managers = group_managers),
    SET_SURVEYS_BY_ORDER: (state, direction) => {
      const { surveys } = state;
      surveys.sort((s1, s2) => {
        if(direction === 'desc') return new Date(s2.created_at) - new Date(s1.created_at);
        return new Date(s1.created_at) - new Date(s2.created_at);
      });
      state.surveys = surveys;
    },
    SET_LOGO: (state, logo) => {
      let { currentUser } = state;
      currentUser = {
        ...currentUser, 
        organization: { 
          ...currentUser.organization,
          logo
        }
      };
      state.currentUser = currentUser;
      window.localStorage.setItem("currentUser", JSON.stringify(state.currentUser));
    },
  },
  actions: {
    ADD_ACTION_STEP({ dispatch, state }, id) {
      Api()
        .post("action_steps/", {
          action_step: { question_id: id, action_step_detail: "" },
        })
        .then(() =>
          dispatch("GET_QUESTION_DETAILS", state.questionDetails.question_id)
        );
    },
    ADD_ADDITIONAL_CONTENT_DETAILS({ dispatch, state }, action_step) {
      Api()
        .post("additional_contents/", {
          additional_content: {
            action_step_id: action_step,
            title: "",
            detail: "",
          },
        })
        .then(() =>
          dispatch("GET_QUESTION_DETAILS", state.questionDetails.question_id)
        );
    },
    ADD_ANSWER({ dispatch, state }) {
      Api()
        .post("question_answers/", {
          question_answer: {
            question_id: state.questionDetails.question_id,
            answer_text: "",
          },
        })
        .then(() =>
          dispatch("GET_QUESTION_DETAILS", state.questionDetails.question_id)
        );
    },
    ADD_ANSWER_SET({ dispatch, state }, args) {
      args.existingAnswers.forEach((a) => {
        dispatch("DELETE_ANSWER", a.answer_id);
      });
      Api()
        .post("attach_answer_set", {
          answer_set_details: {
            question_id: args.question,
            answer_set_id: args.answer,
          },
        })
        .then(() =>
          dispatch("GET_QUESTION_DETAILS", state.questionDetails.question_id)
        );
    },
    ADD_GROUP({ dispatch }, args) {
      Api()
        .post("groups", args.group)
        .then((res) => {
          dispatch("GET_GROUPS");
          args.callback(res.data.id);
        });
    },
    ADD_GROUP_MANAGER({ commit }, args) { 
      Api()
        .post("/group_managers", { 
            group_manager: {
              organization_id: args.organization_id,
              organization_area_id: args.area_id,
            },
         },
         {
          headers: {
            'Authorization': getAuthorizationToken()
          }
        })
        .then(res => commit("SET_GROUP_MANAGER", res.data))
        .catch(err => commit("SET_API_ERROR", { ADD_GROUP_MANAGER: err }));
    },
    ADD_GROUP_SURVEY({ dispatch }, args) {
      Api()
        .post("/add_survey_to_group", args)
        .then(() => dispatch("GET_GROUPS"));
    },
    REMOVE_GROUP_SURVEY({ dispatch }, args) {
      Api()
        .post("/remove_survey_from_group", args)
        .then(() => dispatch("GET_GROUPS"));
    },
    ADD_GROUP_USER({ dispatch }, args) {
      Api()
        .post("/add_user_to_group", args)
        .then(() => dispatch("GET_GROUPS"));
    },
    REMOVE_GROUP_USER({ dispatch }, args) {
      Api()
        .post("/remove_user_from_group", args)
        .then(() => dispatch("GET_GROUPS"));
    },
    ADD_PRESENTATION({ state }, args) {
      let surveyLinkWithOutId = window.location.origin + "/presentation-intro/";
      return Api().post("presentations", {
        presentation: {
          user_id: state.currentUser.id,
          survey_id: args.survey_id,
          name: args.name,
          welcome_message: args.welcome_message,
          thank_you_message: args.thank_you_message,
          link_to_survey: surveyLinkWithOutId,
        },
      });
    },
    ADD_QUESTION({ }, args) {
      Api()
        .post("questions", {
          question: {
            question_text: "",
            question_type: "multiple_choice",
            survey_id: args.survey,
            category: "Content",
          },
        })
        .then((res) => {
          args.callback(res.data.id);
        });
    },
    ADD_SURVEY: ({ }, args) => {
      return Api()
        .post("surveys", args.data, {
          headers: {
            Authorization: getAuthorizationToken()
          }
        })
        .then((res) => {
          args.callback(res.data.id, res.data.existing_questions);
        });
    },
    CREATE_QUESTIONS: ({ }, { data, callback }) => {
      return Api()
        .post("surveys/create_questions", data, {
          headers: {
            Authorization: getAuthorizationToken()
          }
        })
        .then(res => {
          callback(res.data);
        });
    },
    UPDATE_QUESTIONS: ({ }, data) => {
      return Api()
        .patch("surveys/update_questions", data, {
          headers: {
            Authorization: getAuthorizationToken()
          }
        });
    },
    GENERATE_MANAGER_TOKEN: ({ commit }, id) => {
      return new Promise((resolve, reject) => {
        Api()
          .post("group_managers/generate_invitation_token", {}, {
            params: {
              group_manager_id: id
            },
            headers: {
              'Authorization': getAuthorizationToken()
            }
          })
          .then(res => {
            resolve(res.data)
          })
          .catch(err => {
            commit("SET_API_ERROR", { GENERATE_MANAGER_TOKEN: err })
            reject(err)
          });
      });
    },
    CLEAR_GROUP_MANAGER: ({ commit }) => commit("CLEAR_GROUP_MANAGER"),
    CLEAR_SURVEY_DETAILS: ({ commit }) => commit("CLEAR_SURVEY_DETAILS"),
    DECREASE_QUESTION_ORDER({ dispatch, state }, id) {
      Api()
        .put(`questions/${id}/change_orders`, { direction: 1 })
        .then(() => {
          dispatch("GET_SURVEY_DETAILS", state.surveyDetails.survey_id);
        });
    },
    DECREASE_SURVEY_ORDER({ dispatch }, id) {
      Api()
        .put(`surveys/${id}/change_orders`, { direction: 1 })
        .then(() => dispatch("GET_SURVEYS"));
    },
    DELETE_ACTION_STEP({ dispatch, state }, id) {
      Api()
        .delete(`action_steps/${id})`)
        .then(() =>
          dispatch("GET_QUESTION_DETAILS", state.questionDetails.question_id)
        );
    },
    DELETE_ADDITIONAL_CONTENT({ dispatch, state }, id) {
      Api()
        .delete(`additional_contents/${id}`)
        .then(() =>
          dispatch("GET_QUESTION_DETAILS", state.questionDetails.question_id)
        );
    },
    DELETE_ANSWER({ dispatch, state }, id) {
      Api()
        .delete(`question_answers/${id})`)
        .then(() =>
          dispatch("GET_QUESTION_DETAILS", state.questionDetails.question_id)
        );
    },
    DELETE_GROUP: ({ dispatch }, id) =>
      Api()
        .delete(`groups/${id}`)
        .then(() => dispatch("GET_GROUPS")),
    DELETE_PRESENTATION({ dispatch }, id) {
      Api()
        .delete(`presentations/${id}`)
        .then(() => dispatch("GET_PRESENTATIONS"));
    },
    DELETE_QUESTION({ dispatch, state }, id) {
      Api()
        .delete(`questions/${id}`)
        .then(() =>
          dispatch("GET_SURVEY_DETAILS", state.surveyDetails.survey_id)
        );
    },
    DELETE_SURVEY: ({ dispatch }, id) =>
      Api()
        .delete(`surveys/${id}`)
        .then(() => dispatch("GET_SURVEYS")),
    DELETE_SURVEY_QUESTION: ({ }, data) => {
      return Api()
        .delete('surveys/delete_survey_question', {
          params: {
            survey_id: data.survey_id,
            question_id: data.question_id
          },
          headers: {
            Authorization: getAuthorizationToken()
          }
        });
    },
    GET_GROUPS({ commit }) {
      Api()
        .get("groups")
        .then((res) => commit("SET_GROUPS", res.data));
    },
    GET_GROUP_DETAILS({ commit }, id){
      Api()
        .get(`groups/${id}`, {
          headers: {
            Authorization: getAuthorizationToken()
          }
        })
        .then( res => commit("SET_GROUP_DETAILS", res.data));
    },
    GET_GROUP_MANAGER({ commit }, id) {
      Api()
        .get(`group_managers/${id}`, {
          headers: {
            'Authorization': getAuthorizationToken()
          }
        })
        .then(res => commit("SET_GROUP_MANAGER", res.data));
    },
    GET_GROUP_MANAGERS({ commit, state }){
      Api()
        .get('organizations/get_managers', {
          params: {
            id: state.currentUser.organization_id
          },
          headers: {
            'Authorization': getAuthorizationToken()
          }
        })
        .then(res => commit("SET_GROUP_MANAGERS", res.data))
        .catch(err => commit("SET_API_ERROR", { GET_GROUP_MANAGERS: err }));
    },
    GET_PRESENTATION_DETAILS({ commit }, id) {
      return Api()
        .get(`presentations/${id}`)
        .then((res) => commit("SET_PRESENTATION_DETAILS", res.data));
    },
    GET_PRESENTATIONS_METRICS({ commit }) {
      Api().get("user/presentations/average_score_by_category", {
        headers: {
          'Authorization': getAuthorizationToken()
        }
      }).then((res) => commit("SET_PRESENTATIONS_METRICS", res.data));
    },
    GET_RESPONSES_BY_SCORES({ commit }, params) {
      Api().get("user/presentations/responses_by_scores", {
        params: {
          category: params.category,
          presentations_ids: `${params.presentations_ids}`,
        },
        headers: {
          'Authorization': getAuthorizationToken()
        }
      }).then((res) => commit("SET_RESPONSES_BY_SCORES", { category: params.category, data: res.data}));
    },
    GET_QUESTION_DETAILS({ commit }, id) {
      Api()
        .get(`questions/${id}/show_extended_question`)
        .then((res) => commit("SET_QUESTION_DETAILS", res.data.question));
    },
    GET_RESPONSES({ commit }) {
      Api()
        .get("completed_survey_responses")
        .then((res) => commit("SET_RESPONSES", res.data));
    },
    GET_SURVEY_DETAILS({ commit }, id) {
      Api().get(`surveys/${id}/show_extended_survey`).then(res => commit("SET_SURVEY_DETAILS", res.data))
    },
    GET_SURVEY_GROUPS_DETAILS({ commit }) {
      Api().get("/survey_groups", {
        headers: {
          'Authorization': getAuthorizationToken()
        }
      })
        .then(res => {
          let survey_group_details_array = []
          res.data.forEach(survey_group => {
            Api().get(`/survey_groups/${survey_group.id}`, {
              headers: {
                'Authorization': getAuthorizationToken()
              }
            })
              .then(survey_group_detail => {
                survey_group_details_array[survey_group_detail.data.id] = survey_group_detail.data
              })
          })
          survey_group_details_array.sort((n1, n2) => n1 - n2);
          commit("SET_SURVEY_GROUPS_DETAILS", survey_group_details_array)
        });
    },
    GET_SURVEYS: ({ commit }, order) => (
      Api()
      .get('surveys', {
        headers: {
          'Authorization': getAuthorizationToken()
        }
      })
      .then(res => commit("SET_SURVEYS", res.data))
      .finally(() => { 
        if(order) commit("SET_SURVEYS_BY_ORDER", order);
      })
    ),
    GET_SURVEY: ({ }, id) => {
      return Api()
        .get(`surveys/${id}`, {}, {
          Authorization: getAuthorizationToken()
        }).then(res => res.data);
    },
    GET_PLANS: ({ commit }) => (
      Api().get('plans')
        .then(res => commit("SET_PLANS", res.data))
        .catch(err => {
          commit("SET_API_ERROR", { GET_PLANS: err })
        })
    ),
    GET_SURVEY_QUESTIONS: ({ commit }) => (
      Api()
      .get('/surveys/get_survey_questions', {
        headers: {
          Authorization: getAuthorizationToken()
        }
      })
      .then(res => [
        commit("SET_SURVEY_QUESTIONS", res.data), 
        commit("SET_SURVEY_GROUPS", res.data),
      ])
      .catch(err => console.log(err))
    ),
    GET_PLAN_BY_NAME: ({ commit }, name) => (
      Api().get('plans/get_by_name', {
        params: {
          name: name
        }
      }).then(res => commit("SET_PLANS_BY_NAME", res.data))
        .catch(err => {
          commit("SET_API_ERROR", { GET_PLAN_BY_NAME: err })
        })
    ),
    GET_BRAINTREE_TOKEN: ({ commit }) => (Api().get('users/get_braintree_token').then(res => commit("SET_BRAINTREE_TOKEN", res.data))),
    CLEAR_API_ERRORS: ({ commit }) => (commit("CLEAR_API_ERRORS")),
    CLEAR_API_LOGIN_ERRORS: ({ commit }) => (commit("CLEAR_API_LOGIN_ERRORS")),
    CLEAR_RESET_MESSAGE_FLAG: ({ commit }) => (commit("CLEAR_RESET_MESSAGE_FLAG")),
    INCREASE_QUESTION_ORDER({ dispatch, state }, id) {
      Api()
        .put(`questions/${id}/change_orders`, { direction: -1 })
        .then(() => {
          dispatch("GET_SURVEY_DETAILS", state.surveyDetails.survey_id);
        });
    },
    GET_USERS({ commit }) {
      Api()
        .get("users")
        .then((res) =>
          commit(
            "SET_USERS",
            res.data.data.map((u) => u.attributes)
          )
        );
    },
    INCREASE_SURVEY_ORDER({ dispatch }, id) {
      Api()
        .put(`surveys/${id}/change_orders`, { direction: -1 })
        .then(() => dispatch("GET_SURVEYS"));
    },
    ORDER_SURVEYS_LATEST({ commit }) {
      commit("SET_SURVEYS_BY_ORDER", 'desc');
    },
    ORDER_SURVEYS_OLDEST({ commit }) {
      commit("SET_SURVEYS_BY_ORDER", 'asc');
    },
    LOG_IN({ commit }, creds) {
      return new Promise((resolve, reject) => {
        Api().post("login", creds)
          .then(res => {
            // @todo: only commit SET_CURRENT_USER if the response is valid and contains
            // the header 'Authorization'
            commit('SET_CURRENT_USER', res)
            resolve(res.data)
          })
          .catch(err => {
            commit("SET_API_ERROR", { LOG_IN: err })
            reject(err)
          })
      })
    },
    FORGOT_PASSWORD({ commit }, creds) {
      return new Promise((resolve, reject) => {
        Api().post("forgot", creds)
          .then(res => {
            commit("SET_RESET_MESSAGE_FLAG", true)
            resolve(res.data)
          })
          .catch(err => {
            commit("SET_API_ERROR", { FORGOT_PASSWORD: err })
            reject(err)
          })
      })
    },
    RESET_PASSWORD({ commit }, creds) {
      return new Promise((resolve, reject) => {
        Api().post("reset", creds)
          .then(res => {
            resolve(res.data)
          })
          .catch(err => {
            commit("SET_API_ERROR", { RESET_PASSWORD: err })
            reject(err)
          })
      })
    },
    LOG_OUT: ({ commit }) => commit("CLEAR_CURRENT_USER"),
    REGISTER({ commit }, registrationInfo) {
      return new Promise((resolve, reject) => {
        Api().post("signup", registrationInfo)
          .then(res => {
            // @todo: only commit SET_CURRENT_USER if the response is valid and contains
            // the header 'Authorization'
            // commit("SET_CURRENT_USER", res)
            resolve(res.data)
          })
          .catch(err => {
            commit("SET_API_ERROR", { REGISTER: err.response.data.error })
            reject(err)
          })
      })
    },
    REGISTER_ORG({ commit }, registrationInfo) {
      return new Promise((resolve, reject) => {
        Api().post("organizations/signup", registrationInfo)
          .then(res => {
            resolve(res.data)
          })
          .catch(err => {
            commit("SET_API_ERROR", { REGISTER: err.response.data.error })
            reject(err)
          })
      })
    },
    SUBMIT_SURVEY({ state }, results) {
      return Api().post("completed_survey_responses", {
        completed_survey_response: {
          survey_responses: JSON.stringify(results),
          user_id: state.presentationDetails.user_id,
          presentation_id: state.presentationDetails.id,
        },
      });
    },
    PUBLISH_SURVEY({ }, survey_id) {
      return Api()
        .patch("surveys/publish_survey", {
          survey: {
            published_status: "published"
          }
        }, {
          params: {
            id: survey_id,
          },
          headers: {
            Authorization: getAuthorizationToken()
          }
        });
    },
    DRAFT_SURVEY({ }, survey_id) {
      return Api()
        .patch("surveys/publish_survey", {
          survey: {
            published_status: "draft"
          }
        }, {
          params: {
            id: survey_id,
          },
          headers: {
            Authorization: getAuthorizationToken()
          }
        });
    },
    UPDATE_SURVEY({ }, { survey_id, data }) {
      return Api()
        .patch(`surveys/${survey_id}`, data, {
          headers: {
            Authorization: getAuthorizationToken()
          }
        }).then(res => res.data);
    },
    UPDATE_ONBOARDING({ commit }) {
      return new Promise((resolve, reject) => {
        Api().patch("/users/update_onboarding", {}, {
          headers: {
            'Authorization': getAuthorizationToken()
          }
        }).then(res => {
          commit("SET_CURRENT_USER_ONBOARDING", true)
          resolve(true)
        })
          .catch(err => {
            commit("SET_API_ERROR", { UPDATE_ONBOARDING: err })
            reject(err)
          })
      })
    },
    UPDATE_ACTION_STEP({ dispatch, state }, action_step) {
      Api()
        .patch(`action_steps/${action_step.action_step_id}`, {
          action_step: {
            action_step_detail: action_step.action_step_detail,
          },
        })
        .then(() =>
          dispatch("GET_QUESTION_DETAILS", state.questionDetails.question_id)
        );
    },
    UPDATE_ADDITIONAL_CONTENT_DETAILS({ dispatch, state }, additional_content) {
      Api()
        .patch(
          `additional_contents/${additional_content.additional_contents_id}`,
          {
            additional_content: {
              title: additional_content.additional_contents_title,
              detail: additional_content.additional_contents_detail,
            },
          }
        )
        .then(() =>
          dispatch("GET_QUESTION_DETAILS", state.questionDetails.question_id)
        );
    },
    UPDATE_ANSWER_TEXT({ dispatch, state }, answer) {
      Api()
        .patch(`question_answers/${answer.id}`, {
          question_answer: { answer_text: answer.text },
        })
        .then(() =>
          dispatch("GET_QUESTION_DETAILS", state.questionDetails.question_id)
        );
    },
    UPDATE_GROUP({ dispatch }, group) {
      Api()
        .patch(`groups/${group.id}`, { group: group })
        .then(() => dispatch("GET_GROUPS"));
    },
    UPDATE_QUESTION_DETAILS({ dispatch, state }) {
      Api()
        .patch(`questions/${state.questionDetails.question_id}`, {
          question: {
            question_text: state.questionDetails.question_text,
            question_type: state.questionDetails.question_type,
            category: state.questionDetails.category,
          },
        })
        .then(() =>
          dispatch("GET_QUESTION_DETAILS", state.questionDetails.question_id)
        );
    },
    UPDATE_GROUP_MANAGER({ dispatch, state }, data) {
      Api()
        .patch(`group_managers/${state.group_manager.id}`, {
          group_manager: {
            invitation_message: data.invitation_message || state.group_manager.invitation_message,
            organization_id: data.organization_id || state.group_manager.group_manager_admin.organization_id,
            organization_area_id: data.area_id
          },
        },
        {
          headers: {
            'Authorization': getAuthorizationToken()
          }
        })
        .then(() =>
          dispatch("GET_GROUP_MANAGER", state.group_manager.id)
        );
    },
    UPDATE_GROUP_MANAGER_NOTIFICATION({ dispatch, state }, email_notification) {
      Api()
        .patch(`group_managers/${state.group_manager.id}`, {
          group_manager: {
            send_email_group_manager_joined: email_notification
          },
        },
        {
          headers: {
            'Authorization': getAuthorizationToken()
          }
        })
        .then(() =>
          dispatch("GET_GROUP_MANAGER", state.group_manager.id)
        );
    },
    UPDATE_MANAGER({ dispatch, commit, state }, id) {
      Api()
        .patch(`groups/${state.group.id}`, {
          group: {
            manager_id: id
          },
        },
        {
          headers: {
            'Authorization': getAuthorizationToken()
          }
        })
        .then(() =>
          dispatch("GET_GROUP_DETAILS", state.group.id)
        )
        .catch( err => commit("SET_API_ERROR", { UPDATE_MANAGER: err }));
    },
    UPDATE_SURVEY_STATUS({ dispatch }, data) {
      Api()
      .patch(`surveys/update_survey_status`, {
        survey: {
          status: data.status
        }
      }, 
      {
        params: {
          id: data.id,
        },
        headers: {
          Authorization: getAuthorizationToken()
        }
      }).
      then(() => {
        dispatch("GET_SURVEYS", data.order);
      }).catch(err => console.log(error));
    },
    UPDATE_ORGANIZATION_LOGO({ commit }, logo) {
      commit("SET_LOGO", logo);
    },
    UPDATE_ADMIN_CURRENT_VIEW({ commit }, view) {
      commit("SET_ADMIN_CURRENT_VIEW", view)
    },
    SET_PAYMENT_API_ERRORS({ commit }, error) {
      commit("SET_API_ERROR", { PAYMENT: error })
    }
  },
});
